"use client"
import Script from "next/script"
import { useLazyThirdParty } from "@/hooks/useLazyThirdParty"

// GHL form embeds (form_embed.js, white-labelled from link.zip360.co.za). Strictly necessary in the
// cookie banner's terms: it runs the contact, booking and onboarding forms a visitor chooses to use,
// so it does not wait for consent (src/lib/consent.ts). Gating it would break every enquiry.
export function GHLFormScript({ nonce }: { nonce?: string }) {
  // Deferred to first interaction so form_embed.js does not set third-party cookies
  // on a page the visitor never touches. Any click/scroll/keypress loads it before a
  // visitor can reach a form.
  const interacted = useLazyThirdParty()
  if (!interacted) return null
  return (
    <Script
      src="https://link.zip360.co.za/js/form_embed.js"
      strategy="afterInteractive"
      nonce={nonce}
    />
  )
}
